import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Import configs and util modules
import { FormattedMessage } from '../../../../util/reactIntl';

// Import shared components
import { H3 } from '../../../../components';

// Import modules from this directory
import EditListingSizeForm from './EditListingSizeForm';
import css from './EditListingSizePanel.module.css';
import { DAMAGE, LABELS, styleCategories } from '../../../../util/types';
import moment from 'moment';

const EditListingSizePanel = props => {
  const [saveAsDraft, setSaveAsDraft] = useState(false);

  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    history,
    page,
  } = props;
  const { publicData, description } = listing.attributes || {};
  const { size, streetSize, otherImages, productType, material, color, length, sleeves, neckline, anyDamage, heelHeight, style: savedStyle, alterations } = publicData || {};
  const classes = classNames(rootClassName || css.root, className);
  const mapToKeyLabel = (value) => value ? { key: value, label: value } : null;
  const initialValues = {
    description,
    size: mapToKeyLabel(size),
    streetSize: mapToKeyLabel(streetSize),
    material: mapToKeyLabel(material),
    color: mapToKeyLabel(color),
    length: mapToKeyLabel(length),
    sleeves: mapToKeyLabel(sleeves),
    neckline: mapToKeyLabel(neckline),
    heelHeight: mapToKeyLabel(heelHeight),
    anyDamage,
    style: mapToKeyLabel(savedStyle),
    alterations
  };

  return (
    <div className={classes}>
      <div className={css.container}>
        <div className={css.header}>

          <H3 as="h1">
            <FormattedMessage
              id="EditListingSizePanel.createListingTitle"
              values={{ lineBreak: <br /> }}
            />
          </H3>
          {/* <span className={css.measurementIcon}>
            <IconCollection icon="measurementIcon" />
            <FormattedMessage id="EditListingSizePanel.editMeasurements" />
          </span> */}
        </div>
        <EditListingSizeForm
          className={css.form}
          initialValues={initialValues}
          productType={productType}
          onSubmit={values => {
            const { anyDamage, length, description, style, alterations } = values;
            const publicData = LABELS.reduce((acc, key) => {
              const value = values[key]?.label;
              if (value) {
                acc[key] = value;
              }
              return acc;
            }, {
              updatedAt: Math.floor(Date.now() / 1000),
              anyDamage,
            });

            const updateValues = {
              description,
              publicData: {
                ...publicData,
                length: (styleCategories.includes(style?.label || savedStyle)) ? length?.label : null,
                otherImages: (!anyDamage?.trim() && otherImages && otherImages.length > 0) ? otherImages.filter((e) => e.imageType != DAMAGE) : otherImages,
                style: style?.label || null,
                alterations: alterations ? alterations : null
              },
            };
            onSubmit(updateValues);
          }}
          saveActionMsg={submitButtonText}
          disabled={disabled}
          ready={ready}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          fetchErrors={errors}
          setSaveAsDraft={setSaveAsDraft}
          saveAsDraft={saveAsDraft}
          onSaveDraft={onSubmit}
          history={history}
          autoFocus
          listing={listing}
          page={page}
        />
      </div>
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingSizePanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingSizePanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingSizePanel;
